import React, { useEffect, useState } from "react";
import { Plane } from "lucide-react";

export function IntroSplash() {
  const [phase, setPhase] = useState("show");

  useEffect(() => {
    if (phase === "show") {
      const t = setTimeout(() => setPhase("fade"), 2400);
      return () => clearTimeout(t);
    }
    if (phase === "fade") {
      const t = setTimeout(() => setPhase("done"), 700);
      return () => clearTimeout(t);
    }
  }, [phase]);

  if (phase === "done") return null;

  return (
    <div
      data-testid="intro-splash"
      className={`fixed inset-0 z-[100] bg-primary flex flex-col items-center justify-center overflow-hidden transition-opacity duration-700 ${
        phase === "fade" ? "opacity-0 pointer-events-none" : "opacity-100"
      }`}
    >
      {/* soft glow */}
      <div className="absolute w-[36rem] h-[36rem] bg-secondary/20 rounded-full blur-3xl" />

      {/* plane flying across with dashed trail */}
      <div className="relative w-full max-w-xl h-24 mb-2">
        <svg className="absolute inset-0 w-full h-full" viewBox="0 0 600 96" fill="none">
          <path
            d="M10 70 C 150 10, 450 100, 590 30"
            stroke="rgba(255,255,255,0.35)"
            strokeWidth="2"
            strokeDasharray="8 10"
            className="intro-trail"
          />
        </svg>
        <div className="intro-plane absolute top-0 left-0">
          <Plane className="w-9 h-9 text-secondary rotate-12 drop-shadow-lg" />
        </div>
      </div>

      {/* brand reveal */}
      <h1 className="text-3xl md:text-5xl font-bold tracking-widest text-white intro-title">
        CITIZEN <span className="text-secondary">TRAVELS</span>
      </h1>
      <p className="mt-4 text-white/80 text-lg md:text-2xl font-serif intro-tagline">
        ලංකාවට ඇවිත් බලමු
      </p>
      <p className="mt-1 text-white/50 text-xs md:text-sm tracking-[0.3em] uppercase intro-tagline">
        Explore Sri Lanka, Experience More
      </p>
    </div>
  );
}
